module.exports = __webpack_public_path__ + "media/icons/phone-call-8e9e5fd3.png";